/*
Origin Core 1.0

called from /layout/theme.liquid

DEVELOPER NOTE
--------------------
any changes to this file should be noted here, and also noted in the following wiki page:
https://unifiedco.atlassian.net/wiki/spaces/ORIGIN/pages/1413414932/Core+File+Changes+1.0

SUMMARY
--------------------
This script defines a custom web component <localization-form> that manages country and language selection for Shopify localization. 
It handles searching, filtering, and selecting countries, updates the displayed selection, and manages the modal dialog for the selector. 
The script fetches localization suggestions via AJAX, determines the appropriate market, and shows a geolocation popup if needed. 
It also manages user preferences for showing the popup using cookies and provides keyboard accessibility for the selector UI. 
The component is registered if not already defined.

*/

// Market constructor
const market = {};
const markets = [];

// URL (to determine market switch or expansion store redirect)
function Market(name, countries, storeName, url) {
  this.name = name;
  this.countries = countries;
  this.storeName = storeName ? storeName : null;
  this.url = url ? url : null;
}

// set up current markets
const ukMarket = new Market('uk', ['GB'], 'United Kingdom', 'https://boodles-jewellery.myshopify.com');
markets.push(ukMarket);

const euMarket = new Market('eu', ['AT','BE','BG','CY','CZ','DE','DK','EE','ES','FI','FR','GR','HR','HU','IT','LT','LU','LV','MT','NL','PL','PT','RO','SE','SI','SK'], 'EU', 'https://boodles-jewellery.myshopify.com/en-eu');
markets.push(euMarket);

const ieMarket = new Market('ie', ['IE'], 'Ireland', 'https://boodles-jewellery.myshopify.com/en-ie');
markets.push(ieMarket);

const usMarket = new Market('us', ['US','CA'], 'US', 'https://boodles-jewellery.myshopify.com/en-us/');
markets.push(usMarket);

const globalMarket = new Market('global', ['AU','NZ','JP','SG'], 'Global', 'https://boodles-jewellery.myshopify.com/en');
markets.push(globalMarket);

async function fetchRoutes() {
  const response = await fetch(
    window.Shopify.routes.root
      + 'browsing_context_suggestions.json'
      + '?country[enabled]=true'
      + `&country[exclude]=${window.Shopify.country}`
      + '&language[enabled]=true'
      + `&language[exclude]=${window.Shopify.language}`
  );
  return response.json();
}

function showMarketSelectorPopup(newMarket, current_market, country_code, country_name ){

  // Show popup dispatch event
  var customEvent = new CustomEvent('geolocator-show', {
    detail: { 
      open: true,
      newMarket: newMarket,
      country_code: country_code,
      country_name: country_name,
      current_market: current_market
    }
  });

  window.dispatchEvent(customEvent);
}

fetchRoutes().then(res => {
  const country_handle = res?.detected_values?.country?.handle,
  country_lang = res?.suggestions[0]?.parts?.language?.handle,
  country_name = res.detected_values.country_name,
  // what market is the detected country in?
  // First check if it's in EU or UK markets, otherwise default to US market
  detectedCountryMarket = markets.find(market => market.countries.includes(country_handle)) || globalMarket,
  // what market is the current Shopify country in?
  // First check if it's in EU or UK markets, otherwise default to US market
  current_market = markets.find(market => market.countries.includes(Shopify.country)) || globalMarket,
  // Call to start the geolocation
  // check to see if we should show the popup baed on cookie
  show_geo_popup = getCookie('show_geo_popup');

if (show_geo_popup == null || show_geo_popup) {
  // Only show popup if countries are in different markets
  // Also check that both markets exist (not undefined)
  if (detectedCountryMarket && current_market && detectedCountryMarket.name !== current_market.name) {
      showMarketSelectorPopup(detectedCountryMarket, current_market, country_handle, country_name);
  }
}
});

// User has chosen to ignore the popup
// cookie this preference and don't show the popup again for 12 hrs
window.addEventListener('cookie_geo_preference', function(){
  setCookie('show_geo_popup', false, 0.5);
}); 

function setCookie(name,value,days) {
  var expires = "";
  if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}
function eraseCookie(name) {   
  document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}
  